export function findClosest(arr, target) {
    return arr.reduce(function (prev, curr) {
        return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev;
    });
}
//# sourceMappingURL=findClosest.js.map